import React from 'react';
import cl from './Input.module.css';

const Input = ({...rest}) => {
    return <input className={cl.input} {...rest} />
};

export default Input;